import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AESEncryptDecryptService } from 'src/app/AESEncryptDecryptService';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { BeanMonitoryExclusion } from 'src/bean/BeanMonitoryExclusion';
import { MonitoriaComponent } from '../monitoria/monitoria.component';
import { ExclusaoMonitoriaPendenteService } from './exclusao-monitoria-pendente.service';

@Component({
  selector: 'app-exclusao-monitoria-pendente',
  templateUrl: './exclusao-monitoria-pendente.component.html',
  styleUrls: ['./exclusao-monitoria-pendente.component.css']
})
export class ExclusaoMonitoriaPendenteComponent implements OnInit {

  selectedIndex: number = 0;
  monitoryExclusions$ = new MatTableDataSource<BeanMonitoryExclusion>([]);
  public displayedColumns = ['moniIdCdMonitoria', 'formDsFormulario', 'exmoDsMotivo', 'usuaNmUsuario', 'operNmOperacao', 'edit'];
  public sessionExpired = false;

  constructor(
    private exclusaoMonitoriaService: ExclusaoMonitoriaPendenteService,
    private toastr: ToastrService,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    public dialog: MatDialog,
    public monitoriaComponent: MonitoriaComponent,
    private router: Router) { }

  ngOnInit(): void {
    this.getPendencias();
  }

  public update(element: any, choice: string) {

    let dialogTitle = "";
    let dialogText = "";
    if (choice == 'A') {
      dialogTitle = 'Tem certeza que deseja APROVAR esta solicitação de exclusão?';
      dialogText = 'Caso a solicitação de exclusão seja aprovada, não será possível recuperar os dados da monitoria.';
    } else {
      dialogTitle = 'Tem certeza que deseja REPROVAR esta solicitação de exclusão?';
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        dialogTitle: dialogTitle,
        dialogText: dialogText
      }, width: '320px'
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result){
        element.exmoDsStatus = choice;
        element.usuaIdCdUsuarioAprovacao = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());
        choice == 'A' ? element.exmoDhAprovacao = '1900-01-01T00:00:00' : element.exmoDhAprovacao = null;

        this.exclusaoMonitoriaService.update(element.exmoIdCdExclusaoMonitoria, element).subscribe((retorno: any) => {
          let message = choice == 'A' ? 'Exclusão aprovada com sucesso!' : 'Exclusão reprovada com sucesso!';
          this.toastr.success(message, 'Salvo');
          this.getPendencias();
        }),
          errorResponse => {
            this.toastr.error(errorResponse?.error?.message, 'Erro');
          }
      }
    });


  }

  public getPendencias() {
    this.exclusaoMonitoriaService.list()
      .then((monitoryExclusions: BeanMonitoryExclusion[]) => {
        this.monitoryExclusions$.data = monitoryExclusions;
      },
        errorResponse => {
          this.setSessionExpired(errorResponse) ?
            this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.', 'Solicitação de Exclusão') : this.toastr.warning(errorResponse?.error?.message, 'Solicitação de Exclusão');
          this.monitoryExclusions$.data = [];
        }).catch((retorno: any) => {
          if (retorno.error.error_description.indexOf("Access token expired") > -1) {
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
        });

  }

  public setSessionExpired(errorResponse: any): boolean {
    if (errorResponse.status == 401) {
      this.sessionExpired = true;
    }
    return this.sessionExpired;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.monitoryExclusions$.filter = filterValue.trim().toLowerCase();
    if (this.monitoryExclusions$.paginator) {
      this.monitoryExclusions$.paginator.firstPage();
    }
  }

  detailRow(monitoryId: number) {
    this.monitoriaComponent.listarMonitoriaById(String(monitoryId));
  }

}
